import { epoch, utc } from '../../util/datetime';
import type { IObjectiveSignedDocuments } from './ObjectiveSignedDocuments.interface';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveSignedDocuments implements IObjectiveSignedDocuments {
  creditProposal: YesNoOption;
  creditProposalDate: number;
  creditProposalComments: string;

  static build = (data: IObjectiveSignedDocuments) => new ObjectiveSignedDocuments(data);
  static blank = () => new ObjectiveSignedDocuments();

  /**
   * Constructor
   * @param {IObjectiveSignedDocuments} data
   */
  constructor(data?: IObjectiveSignedDocuments) {
    this.creditProposal = YesNoOption.of(data?.creditProposal?.name);
    this.creditProposalDate = data?.creditProposalDate
      ? epoch(utc(data?.creditProposalDate))
      : 0;
    this.creditProposalComments = data?.creditProposalComments || '';
  }
}
